class OgnRequest {
    ognGiris: boolean = false;
    code?: string = "";
    state?: string = "";
    lang?: number = 1;
    uygulamaKodu: string = "";
}
export default OgnRequest;